<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">{{ $t('common.loading') }}</dv-loading>

      <div v-else>
        <!-- head -->
        <div class="headBox">
          <div style="position: relative;height: 100%;">

            <div style="position: absolute;left: 10px;top: 20px;display: flex;">

              <div style="margin-top: -20px;margin-right: 8px;">
                <svg v-if="goFullscreenType" @click="exitFullscreen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <!-- 左上角缩小 -->
                  <path d="M8 3v3a2 2 0 0 1-2 2H3"/>
                  <!-- 右下角缩小 -->
                  <path d="M21 8h-3a2 2 0 0 1-2-2V3"/>
                  <!-- 右上角缩小 -->
                  <path d="M16 21v-3a2 2 0 0 1 2-2h3"/>
                  <!-- 左下角缩小 -->
                  <path d="M3 16h3a2 2 0 0 1 2 2v3"/>
                </svg>

                <svg v-else @click="goFullscreen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <!-- 左上角展开 -->
                  <path d="M3 8V3h5"/>
                  <!-- 右上角展开 -->
                  <path d="M21 8V3h-5"/>
                  <!-- 左下角展开 -->
                  <path d="M3 16v5h5"/>
                  <!-- 右下角展开 -->
                  <path d="M21 16v5h-5"/>
                </svg>
              </div>

              <span style="font-size: 22px;color: #fff;">{{ weatherData.temperature_float }} °C</span>

              <!-- 晴 qi-100  多云 qi-101 雨 qi-307 雪 qi-401 -->

              <i class="qi-100" v-if="snowFill == 'qing'" style="font-size: 32px;margin-left: 15px;"></i>
              <i class="qi-307" v-else-if="snowFill == 'yu'" style="font-size: 32px;margin-left: 15px;"></i>
              <i class="qi-401" v-else-if="snowFill == 'xue'" style="font-size: 32px;margin-left: 15px;"></i>
              <i class="qi-101" v-else style="font-size: 32px;margin-left: 15px;"></i>

              <div style="margin-left: 5px;">
                <span v-if="snowFill == 'qing'">{{ $t('weather.sunny') }}</span>
                <span v-else-if="snowFill == 'yu'">{{ $t('weather.rainy') }}</span>
                <span v-else-if="snowFill == 'xue'">{{ $t('weather.snowy') }}</span>
                <span v-else>{{ $t('weather.cloudy') }}</span>
              </div>
            </div>

            <p style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
              <span style="font-size: 24px;font-weight: 600;color: #fff;">{{ $t('header.title') }}</span>
            </p>

            <div
              style="width: 32%;position: absolute;right: 10px;top: 20px;display: flex;justify-content: space-between;">
              <div style="display: flex; align-items: center;">
                
                <div class="quad-box openAdmin" @click="openAdmin">
                  <div class="quad-box-inner">
                    <div class="quad-front">
                      <div class="text-content" style="opacity: 0;">
                        <div v-if="$i18n.locale === 'zh'">
                          <div>后</div>
                          <div>台</div>
                          <div>控</div>
                          <div>制</div>
                        </div>
                        <div v-else>
                          Admin
                        </div>
                      </div>
                    </div>
                    <div class="text-content1">
                      <template v-if="$i18n.locale === 'zh'">
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">后 </div>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">台 </div>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">控 </div>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">制 </div>
                      </template>
                      <template v-else>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px; font-size: 16px;">Admin</div>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- 三相电 -->
                <div class="quad-box openAdmin" style="margin-left: 15px" @click="threeGo">
                  <div class="quad-box-inner">
                    <div class="quad-front">
                      <div class="text-content" style="opacity: 0;">
                        <div v-if="$i18n.locale === 'zh'">
                          <div>三</div>
                          <div>相</div>
                          <div>电</div>
                        </div>
                        <div v-else>
                          3-Phase
                        </div>
                      </div>
                    </div>
                    <div class="text-content1">
                      <template v-if="$i18n.locale === 'zh'">
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">三 </div>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">相 </div>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px;">电 </div>
                      </template>
                      <template v-else>
                        <div style="transform: skew(0deg) rotate(-25deg);margin-top: 2px; font-size: 16px;">3-Phase</div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              

              <div style="display: flex;flex-direction: row;align-items: flex-start;">
                <!-- 语言切换按钮 -->
                <div class="lang-switch" @click="toggleLang" style="cursor: pointer; margin-right: 15px; color: #fff; border: 1px solid #409EFF; padding: 2px 8px; border-radius: 4px; font-size: 14px;display: flex;">

                  <img v-if="$i18n.locale === 'zh'" src="../assets/cn.png" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
                  <img v-else src="../assets/en.jpg" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
                  
                  <span>{{ $i18n.locale === 'zh' ? '🇨🇳 中' : '🇬🇧 EN' }}</span>
                </div>

                <span style="font-size: 18px;color: #fff;margin-right: 10px;">{{ dateYear }}</span>
                <span style="font-size: 24px;color: #fff;">{{ dateDay }}</span>
              </div>
            </div>


          </div>
        </div>
        <div style="display: flex;">
          <!-- 第一列 -->
          <div style="width: 30%;">
            <indexLeft01 :device_number_list="homeData.device_number_list"></indexLeft01>
            <indexLeft02 :photovoltaicYery="photovoltaicYery"></indexLeft02>
            <indexLeft03 :totalEcele_month="homeData.totalEcele_month" :batEcele_month="homeData.batEcele_month"
              :sun_charge_Power_month="homeData.sun_charge_Power_month"></indexLeft03>
          </div>

          <!-- 第二列 -->
          <div style="width: 40%;display: flex;flex-direction: column;">
            <div style="width: 100%;" class="ditu" @click="goTo">
              <CenterLeft2Chart v-if="homeData.areas_json" :cdata="homeData.area" :Region="homeData.areas_json" />
            </div>
            <indexCenter :lang="lang" :photovoltaicType="1" :cdata="homeData.monthData"></indexCenter>
          </div>

          <!-- 第三列 -->
          <div style="width: 30%;">
            <div @click="goTOBms">
              <indexRight01 :energy_storage="homeData.energy_storage"></indexRight01>
            </div>

            <div @click="goToElectricity('2')">
              <indexRight02 :photovoltaic="homeData.photovoltaic"></indexRight02>
            </div>

            <div @click="goToElectricity('1')">
              <indexRight03 :mains="homeData.mains"></indexRight03>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import dvBgiBox from '@/components/dvBgiBox/index'
import indexCenter from '@/components/dvBgiBox/indexCenter'
import indexLeft01 from '@/components/dvBgiBox/indexLeft01'
import indexLeft02 from '@/components/dvBgiBox/indexLeft02'
import indexLeft03 from '@/components/dvBgiBox/indexLeft03'

import indexRight01 from '@/components/dvBgiBox/indexRight01'
import indexRight02 from '@/components/dvBgiBox/indexRight02'
import indexRight03 from '@/components/dvBgiBox/indexRight03'

import CenterLeft2Chart from "@/components/echart/centerLeft/centerLeft2Chart";

let dtData = require('../utils/dtData.json');
import drawMixin from "../utils/drawMixin";
import { formatTime } from "../utils/index.js";
import { indexDataAPI } from "@/api";

export default {
  mixins: [drawMixin],
  data() {
    return {
      type: 2,  //类型:1=数字工厂,2=智慧路灯,3=储能箱
      // 1 为削锋填谷储能照明  2 为光伏储能照明
      photovoltaicType: 1,

      jianKongUrl: '',

      homeData: {},
      device_list: {},

      project_id: '',
      project_id_g: '',

      lightningNum: '90',
      lightningType: '2',

      dianbiao: 0,
      dianliang: 0,
      photovoltaicYery: '',

      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      weekdayEn: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      decorationColor: ["#568aea", "#000000"],

      cDataRight01: {},

      weatherData: {},
      snowFill: '',

      goFullscreenType: false  // 是否全屏
    };
  },
  components: {
    // dvBgiBox,
    indexCenter,
    indexLeft01,
    indexLeft02,
    indexLeft03,
    CenterLeft2Chart,
    indexRight01,
    indexRight02,
    indexRight03
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    lang: {
      handler() {
        this.timeFn();
      }
    }
  },
  mounted() {

    // this.cancelLoading();
    if (localStorage.getItem('lang')) {
      this.$i18n.locale = localStorage.getItem('lang')
      console.log(this.$i18n.locale,'this.$i18n.locale');
      
    }

    let query = this.$route.query; // { key1: value1, key2: value2 }
    if (query.p) {
      this.project_id = query.p
    }
    if (query.g) {
      this.project_id_g = query.g
    }

    // this.jianKongUrl = 'https://xkdpcamera.xujingkj.com?p=' + this.project_id
    // this.jianKongUrl = 'https://xkdpcamera.xujingkj.com/jiankong/wpdemo.html'
    this.dataAPI()
  },
  beforeDestroy() {
    clearInterval(this.timing);
  },
  methods: {
    toggleLang() {

      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLang;
      localStorage.setItem('lang', newLang);
      // 如果有需要，可以刷新部分组件或重新获取数据
      
    },

    restapi(adcode) {
      let that = this
      // 创建XMLHttpRequest对象
      var xhr = new XMLHttpRequest();
      // 配置请求方式和请求地址
      xhr.open('GET', `https://restapi.amap.com/v3/weather/weatherInfo?city=${adcode}&key=dbd4778b82c74a18e3995a4bde0473bf`, true);
      // 发送请求
      xhr.send();
      // 监听响应状态变化
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          // 处理响应数据
          var res = JSON.parse(xhr.responseText);
          that.weatherData = res.lives[0]
          console.log(that.weatherData);

          if (that.weatherData.weather.includes('雨')) {
            that.snowFill = 'yu'
          } else if (that.weatherData.weather.includes('晴')) {
            that.snowFill = 'qing'
          } else if (that.weatherData.weather.includes('雪')) {
            that.snowFill = 'xue'
          } else {
            that.snowFill = 'yin'
          }

          console.log(that.snowFill);

        }
      };
    },


    async dataAPI() {
      let obj = {}
      if (this.project_id) {
        obj = { p: this.project_id }
      }
      if (this.project_id_g) {
        obj = { g: this.project_id_g }
      }
      const res = await indexDataAPI(obj);

      this.homeData = res

      this.device_list['xData'] = this.homeData.device_list
      this.device_list['seriesData'] = this.homeData.device_number_list

      // 类型:1=数字工厂,2=智慧路灯,3=储能箱
      this.type = this.homeData.type

      // 低谷充电
      this.dianliang = this.homeData.totalEcele_month
      // 放电量
      this.dianbiao = this.homeData.batEcele_month
      // 光伏充电量(年
      this.photovoltaicYery = this.homeData.sun_charge_Power_month

      // 监控网址
      if (this.homeData.monitor_url) {
        this.jianKongUrl = this.homeData.monitor_url + '?p=' + this.project_id
      } else {
        this.jianKongUrl = 'https://xkdpcamera.xujingkj.com?p=' + this.project_id
      }

      // soc的总和/电池个数

      // this.socN =



      // this.lightningNum = this.homeData.device_info.battery
      // if (this.homeData.device_info.dumpEnergy > 26.5 || this.homeData.device_info.dumpEnergy < 27) {
      //   this.lightningNum = 100
      // } else if (this.homeData.device_info.dumpEnergy < 22) {
      //   this.lightningNum = 10
      // }

      if (!this.homeData.areas_json) {
        this.homeData.areas_json = JSON.stringify(dtData)
      }

      // 天气
      let rr = JSON.parse(this.homeData.areas_json)
      this.restapi(rr.features[0].properties.adcode)


      this.timeFn();
      // this.device_info()

      this.timing = setInterval(() => {
        this.loading = false;
      }, 1200);
      // console.log(this.homeData.device_number_list, "aaaaaaaaaaaaaaaaaaaaaaaaa");
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");

        if (this.lang == 'zh') {
          this.dateWeek = this.weekday[new Date().getDay()];
        }
        if (this.lang == 'en') {
          this.dateWeek = this.weekdayEn[new Date().getDay()];
        }
        
      }, 1000);
    },

    // 充电状态
    device_info() {


      let da = formatTime(new Date(), "HH: mm")
      // console.log(da);
      // da = '06:00'
      // if(this.isBetweenTime(da, [this.homeData.device_info.gled_a, this.homeData.device_info.gled_a_b])) {
      // console.log(this.isBetweenTime(da, [this.homeData.device_info.gled_a, this.homeData.device_info.gled_a_b]));
      // console.log(this.isBetweenTime(da, [this.homeData.device_info.gled_b_c, (formatTime(new Date(), "yyyy-MM-dd")) + this.homeData.device_info.gled_d]));
      // }


      // this.homeData.device_info.gled_a = "12:00"
      // this.homeData.device_info.gled_a_b = "12:20"
      // this.homeData.device_info.gled_b_c = "12:30"
      // this.homeData.device_info.gled_c_d = "12:40"
      // this.homeData.device_info.gled_d = "12:50"


      // 1 充电状态  2 放电状态  3 市电状态    其他 剩余电池电量 
      if (this.isBetweenTime(da, [this.homeData.device_info.gled_a, this.homeData.device_info.gled_a_b])) {
        this.lightningType = 2
      } else if (this.isBetweenTime(da, [this.homeData.device_info.gled_a_b, this.homeData.device_info.gled_b_c])) {
        this.lightningType = 3
      } else if (this.isBetweenTime(da, [this.homeData.device_info.gled_b_c, this.homeData.device_info.gled_d])) {
        this.lightningType = 1
      } else {
        this.lightningType = 1
      }



      // console.log(this.isBetweenTime(da, [this.homeData.device_info.gled_a, this.homeData.device_info.gled_a_b]));
      // console.log(this.isBetweenTime(da, [this.homeData.device_info.gled_a_b, this.homeData.device_info.gled_b_c]));
      // console.log(this.isBetweenTime(da, [this.homeData.device_info.gled_b_c, this.homeData.device_info.gled_d]));


    },

    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },





    // tab栏切换
    photovoltaicFun(num) {
      if (num == 1) {
        console.log('11111');
      } else if (num == 2) {
        console.log('22222', this.homeData.monthData);
        this.homeData.monthData.photovoltaicData = this.homeData.monthData.lineData
      }

      this.photovoltaicType = num

    },






    isBetweenTime(currentDate, timeQuantum) {
      let isBetween = true;
      let currentTime = new Date('2023-01-01 ' + currentDate);
      let startTime = new Date('2023-01-01 ' + timeQuantum[0]);
      let endTime = new Date('2023-01-01 ' + timeQuantum[1]);
      if (startTime.getTime() > endTime.getTime()) {
        if (currentTime.getHours() < '12') {
          currentTime = new Date('2023-01-02 ' + currentDate);
        }
        endTime = new Date('2023-01-02 ' + timeQuantum[1]);
      }

      let t1 = currentTime.getTime() - startTime.getTime();
      let t2 = currentTime.getTime() - endTime.getTime();
      if (t1 < 0 || t2 > 0) {
        isBetween = false;
      }

      return isBetween;
    },


    openAdmin() {
      window.open('https://hzxk.xujingkj.com/admin/dashboard');
    },

    threeGo() {
      let obj = {}
      if (this.project_id) {
        obj = { p: this.project_id }
      }
      if (this.project_id_g) {
        obj = { g: this.project_id_g }
      }
      let routeData = this.$router.resolve({
      query: obj,
      path: '/threePhase'
      });
      window.open(routeData.href, '_blank');
    },

    goTo() {
      let obj = {}
      if (this.project_id) {
        obj = { p: this.project_id }
      }
      if (this.project_id_g) {
        obj = { g: this.project_id_g }
      }
      this.$router.push({ path: '/map', query: obj });
    },
    goToElectricity(type) {
      console.log('wwwwwwwwww');
      let obj = {}
      if (this.project_id) {
        obj = { p: this.project_id, t: type }
      }
      if (this.project_id_g) {
        obj = { g: this.project_id_g, t: type }
      }
      this.$router.push({ path: '/Electricity', query: obj });
    },
    // 前往BMS电池
    goTOBms() {
      let obj = {}
      if (this.project_id) {
        obj = { p: this.project_id }
      }
      if (this.project_id_g) {
        obj = { g: this.project_id_g }
      }
      this.$router.push({ path: '/BMS', query: obj });
    },

     // 进入全屏
 goFullscreen() {
     this.goFullscreenType = true
    const elem = document.documentElement; // 整个页面全屏
    // 或者指定某个元素: const elem = document.getElementById('myElement');
    
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { // Safari
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { // IE/Edge
        elem.msRequestFullscreen();
    }
},

// 退出全屏
 exitFullscreen() {
    this.goFullscreenType = false
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { // Safari
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
    }
},


  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";

#index {
    color: #d3d6dd;
    width: 1920px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        padding: 16px 16px 0 16px;
        background-image: url("../assets/pageBg.png");
        background-size: cover;
        background-position: center center;
    }
}

.headBox {
  width: 100%;
  height: 100px;
  background-image: url("../assets/headBox.png");
  background-size: 100% 100%;
  ;
}

.openAdmin {
  // padding: 5px 10px;
  // border: 2px solid #73c3d4;
  border-radius: 10px;
  // margin-top: -10px;
  // margin-right: 60px;
  cursor: pointer;
}

.goto {
  border: 1px solid #2e6099;
  border-radius: 5px;
  padding: 8px;
}

.photovoltaicTypeBg {
  background-color: #43d2fe !important;
}

.cur {
  cursor: pointer;
}

.ditu {
  background-image: url("../assets/ditu.png");
  background-size: 100% 100%;
}

.quad-box {
  // position: relative;
  // width: 300px;
  // height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
  cursor: pointer;
  transition: transform 0.3s;
}

.quad-box:hover {
  // transform: translateY(-10px);
  transform: scale(1.2);
}

.quad-box-inner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 20px;
  transition: transform 0.5s;
  transform-style: preserve-3d;
  margin-top: -20px;
}

.quad-box:hover .quad-box-inner {
  // transform: rotateY(180deg);
}

.quad-front,
.quad-back {
  // position: absolute;
  // width: 100%;
  // height: 100%;
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.quad-front {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transform: skew(315deg);
}

.quad-back {
  background: rgba(0, 0, 0, 0.7);
  transform: skew(-15deg) rotateY(180deg);
  color: white;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-content {
  transform: skew(344deg) rotate(-15deg);
  text-align: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 10px;
  padding: 0px 15px;
}

.text-content1 {
  position: absolute;
  transform: skew(0deg) rotate(45deg);
  text-align: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 0px 15px;
}

.back-text {
  transform: skew(344deg) rotate(-15deg);
  font-size: 16px;
  line-height: 1.6;
}
</style>
